<template>
  <!-- <div class="cookie-banner" v-if="!userAcceptedCookies"> -->
  <div class="cookie-banner">
    <div class="cookie__wrapper">
      <h1 class="h3">Diese App verwendet Cookies</h1>
      <p>
        teamee verwendet essenzielle Cookies, um eine fehlerfreie und sichere Nutzung der App ermöglichen zu können. Durch die weitere Nutzung der App stimmst
        du dieser Verwendung zu. Zum anderen werden anonymisierte Tracking-, bzw. Analysedaten für die stetige Weiterentwickung und Verbesserung der App
        eingesetzt. Deine Einstellungen kannst du jeder Zeit im <span @click="openLegal">Datenschutzbereich</span> dieser App bearbeiten. Weitere Informationen
        findest du in unserer <span @click="openLegal">Datenschutzerklärung</span>.
      </p>
      <div class="button__wrapper">
        <button class="button__transparent" @click="acceptEssentialCookies">nur notwendige Cookies erlauben</button>
        <button class="cta button__cta" @click="enableTracking">alle Cookies erlauben</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CookieBanner",
  methods: {
    // As soon as the User accepts any kind of Cookies, the 'acceptCookies' Cookie will be set for 1 Year
    setCookies() {
      let d = new Date();
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * 365); // expires in 1 year
      document.cookie = "acceptCookies" + "=" + "true" + ";path=/;expires=" + d.toGMTString();

      this.$store.commit("SET_COOKIES", true);
    },
    // If User accepts all Cookies, the 'acceptGACookies' Cookie will be set. Also, Google Analytics will be activated (Opt-In)
    setGACookies() {
      let d = new Date();
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * 365); // expires in 1 year
      document.cookie = "acceptGACookies" + "=" + "true" + ";path=/;expires=" + d.toGMTString();

      this.$store.commit("SET_GA_COOKIES", true);
    },
    acceptEssentialCookies() {
      this.setCookies();
      this.$store.commit("SET_COOKIES", true);
    },
    enableTracking() {
      this.setCookies();
      this.setGACookies();

      this.$ga.enable(); // enable Google Analytics
    },
    openLegal() {
      this.$store.commit("SET_LEGAL_COMPONENT", "PrivacyPolicy");
      this.$router.push("Legal");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_globals.scss";

.cookie-banner {
  z-index: 1000;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.479);
  .cookie__wrapper {
    background-color: $white;
    padding: 24px;
    h1,
    p,
    span {
      color: $darker-navy-blue;
    }
    h1 {
      line-height: 1.5;
      margin-bottom: 24px;
    }
    p {
      line-height: 1.5;
      margin-bottom: 40px;
      span {
        cursor: pointer;
        text-decoration: underline;
      }
    }
    .button__wrapper {
      display: flex;
      justify-content: flex-end;
      flex-wrap: wrap;
      .button__transparent {
        color: $darker-navy-blue;
        border: 1px solid transparent;
        width: 299px;
        &:hover {
          background: none;
          text-decoration: underline;
        }
        @media screen and (max-width: 540px) {
          margin-right: 0;
        }
      }
      .cta {
        margin-left: 12px;
        width: 299px;
      }
    }
  }
}
</style>
